import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { GeoProvider } from './context/GeoContext';
import { AnonConsentProvider } from './context/AnonConsentContext';

// IMPORTANT: keep your global styles import here.
// Use the correct path/name for your project:
import './index.css';           // or './styles/index.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GeoProvider>
      <AnonConsentProvider>
        <App />
      </AnonConsentProvider>
    </GeoProvider>
  </React.StrictMode>
);
